import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { Box, Button, Card, Chip, Grid, Typography } from '@mui/material';
import ReactPlayer from 'react-player';
import { getQuestionsRequest } from '../../redux/actions/getQuestions';
import QuestionListItem from '../../components/Questions/QuestionListItem';
import AddQuestionDialog from '../../components/Questions/AddQuestionDialog';
import { useAsyncError } from 'react-router-dom';
import { compareDataForUpdateOnServer, getChangedItemsInArray, getUpdatedObject } from '../../utility/GenersGridUtils';

function SuperAdminQuestions(props) {

  const [questionsList, getQuestionsList] = useState(null)
  const [showAddQuestionDialog, setShowAddQuestionDialog] = useState(false);
  const [editableQuestion,setEditableQuestion] = useState(null);

  const callQuestionListApi = () => {
    props?.getQuestions();
  }

  useEffect(() => {
    if (!props?.ques_list_loading && !props?.ques_list_data) {
      callQuestionListApi();
    }
  }, []);

  useEffect(() => {
    if (!questionsList && !props?.ques_list_loading && props?.ques_list_data) {
      const data = props?.ques_list_data?.data;
      console.log("ques_list_data : ", data)
      getQuestionsList(data);
    }
    else{
      console.log("Updated questionsList:", questionsList);
      getQuestionsList(questionsList);
    }
  }, [props?.ques_list_data, props?.ques_list_error, props?.ques_list_loading, questionsList]);

  const updateToserver = () => {
    console.log("original : ",props?.ques_list_data);
    console.log("modified : ",questionsList);

    // const comapreResult = compareDataForUpdateOnServer(props?.ques_list_data,questionsList);
    // if (!comapreResult) {
    //   var i_original = props?.ques_list_data;
    //   var i_modified = questionsList;
    //   const changes = getUpdatedObject(i_original, i_modified);    // Only returns the changed structure
    //   const { added, removed, modified } = getChangedItemsInArray(i_original, i_modified);
    //   console.log("changes : ",changes);
    //   console.log("added : ",added);
    //   console.log("removed : ",removed);
    //   console.log("modified : ",modified);
    // }
  }

  const mediaPreview = (item) => {
    const isMultimedia = item?.multimedia;
    const multimedia_type = item?.multimedia?.type;
    const multimedia_url = item?.multimedia?.details?.url;
    switch (multimedia_type) {
      case "image":
        return (
          <img
            src={multimedia_url}
            alt={item.title}
            style={{ width: "100%", height: 180, objectFit: "contain" }}
          />
        );
      case "video":
        if (multimedia_url.includes("vimeo.com")) {
          const videoId = multimedia_url.split("/").pop();
          return (
            <iframe
              //src={`https://player.vimeo.com/video/${videoId}?title=0&byline=0&portrait=0&badge=0&autopause=0`}
              src={multimedia_url}
              width="100%"
              height="180"
              frameBorder="0"
              allow="fullscreen; autoplay"
              //allowFullScreen
              title={item.title}
            />
          )
        }
        else {
          return (
            // <video width="100%" height="180" controls style={{ objectFit: "cover" }}>
            //   <source src={item.url} type="video/mp4" />
            //   Your browser does not support the video tag.
            // </video>
            <Box sx={{ height: 180, display: "flex", alignItems: "center", justifyContent: "center", background: "#f5f5f5" }}>
              <ReactPlayer
                //url="https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8"
                url={multimedia_url}
                controls={true}
                playing={false}
                width="100%"
                height="100%"
              />
            </Box>
          );
        }
      case "audio":
        return (
          <Box sx={{ height: 180, display: "flex", alignItems: "center", justifyContent: "center", background: "#f5f5f5" }}>
            <audio
              controls
            //controlsList="nodownload noplaybackrate noremoteplayback nofullscreen noautoplay"
            >
              <source src={multimedia_url} type="audio/mpeg" />
              Your browser does not support the audio element.
            </audio>
          </Box>
        );
      case "text":
        return (
          <Box sx={{ height: 180, p: 2, overflow: "auto", background: "#f5f5f5" }}>
            <Typography variant="body2">{item.content}</Typography>
          </Box>
        );
      default:
        return (
          <Box sx={{ height: 180, background: "#eee", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography variant="caption">Unsupported Media</Typography>
          </Box>
        );
    }
  };

  return (
    <div style={styles.container}>
      <Box sx={{ flex: 1, height: "100%", padding: 4, marginTop: 2 }}>

        {/* Title + Create + Update button in a row */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0,
            px: 2
          }}>

          </Box>

          {/* Create */}
          <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0,
            px: 2
          }}>
            <Button
              variant="contained"
              color="success"
              sx={{ borderRadius: 2, textTransform: "none", px: 4 }}
              onClick={() => {
                console.log("create button clicked!! : ",editableQuestion)
                setEditableQuestion(null);
                setShowAddQuestionDialog(true);
              }}
            >
              Create
            </Button>

            {/* Update */}
            <Button
              variant="contained"
              color="error"
              sx={{ borderRadius: 2, textTransform: "none", px: 4, ml: 4 }}
              onClick={() => {
                updateToserver();
              }}
            >
              Update
            </Button>
          </Box>

        </Box>

        {questionsList && 
        <Box sx={{ p: 2 }}>
          <QuestionListItem 
          key={questionsList?.length} 
          question_data={questionsList} 
          showAddQuestionDialog={showAddQuestionDialog} 
          setShowAddQuestionDialog={setShowAddQuestionDialog}
          editableQuestion={editableQuestion}
          setEditableQuestion={setEditableQuestion}
          callQuestionListApi={callQuestionListApi}
          />
        </Box>}
      </Box>
    </div>
  );
}

// Simple inline styles
const styles = {
  container: {
    padding: '40px',
    textAlign: 'center',
  },
};

// mapStateToProps (to access Redux state)
const mapStateToProps = (state) => {
  return {
    ques_list_data: state?.questions?.ques_list_data,
    ques_list_loading: state?.questions?.ques_list_loading,
    ques_list_error: state?.questions?.ques_list_error,
  }
};

// mapDispatchToProps (to dispatch Redux actions)
const mapDispatchToProps = { getQuestions: getQuestionsRequest };

// connect to Redux
export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminQuestions);